import { MapPin, Phone, Globe, Clock } from "lucide-react";
import { CONTACT } from "../lib/menuData";

export const Footer = () => (
  <footer className="relative bg-teal-dark border-t border-gold/20 pt-20 pb-10 grain overflow-hidden">
    <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-10">
      <div className="text-center mb-16">
        <h2 className="font-serif text-cream leading-none text-[16vw] md:text-[11rem] tracking-tight">
          Ceylon <span className="italic text-gold">Royal</span>
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-10 border-t border-gold/15 pt-12">
        <div className="flex items-center gap-4">
          <img src="/logo.png" alt="Ceylon Royal Kitchen" className="h-16 w-auto rounded-md" />
          <div>
            <div className="font-serif text-xl text-cream">Ceylon Royal Kitchen</div>
            <div className="text-cream/55 text-sm">Tamilische Küche · Karlsruhe</div>
          </div>
        </div>

        <div className="space-y-3 text-cream/70 text-sm">
          <div className="flex items-center gap-2"><MapPin size={15} className="text-gold" /> {CONTACT.address}</div>
          <div className="flex items-center gap-2"><Clock size={15} className="text-gold" /> {CONTACT.hours}</div>
          <div className="flex items-center gap-2"><Phone size={15} className="text-gold" /> <a href={CONTACT.phoneHref} className="link-underline">{CONTACT.phone}</a></div>
          <div className="flex items-center gap-2"><Globe size={15} className="text-gold" /> {CONTACT.website}</div>
        </div>

        <div className="flex flex-col md:items-end gap-3">
          <a href="#speisekarte" data-testid="footer-order-btn"
            className="bg-gold text-teal-dark px-6 py-3 rounded-full font-medium hover:bg-gold-light transition-colors w-fit">
            Jetzt bestellen
          </a>
        </div>
      </div>

      <div className="mt-12 pt-6 border-t border-gold/10 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 text-cream/40 text-xs">
        <span>© {new Date().getFullYear()} Ceylon Royal Kitchen · Karlsruhe</span>
        <nav className="flex items-center gap-5">
          <a href="/impressum" data-testid="footer-impressum" className="link-underline hover:text-cream/80">Impressum</a>
          <a href="/datenschutz" data-testid="footer-datenschutz" className="link-underline hover:text-cream/80">Datenschutz</a>
          <a href="/agb" data-testid="footer-agb" className="link-underline hover:text-cream/80">AGB</a>
        </nav>
      </div>
    </div>
  </footer>
);
